<template>
  <input
    :id="getId()"
    :value="value"
    class="form-control"
    type="text"
    :disabled="disabled"
    @input="onInput($event.target.value)"
  />
</template>

<script>
import Field from './Field.vue';

export default {
  extends: Field
};
</script>
